<template>
  <div>
    <div class="container">
      <h2 class="font-weight-bold font-size-medium text-center text-md-left">
        Resultado de buscas pelo termo: <span class="text-color2 cursor-pointer" @click="$emit('toggle-search', $event)">{{ term }}</span>
      </h2>
    </div>

    <!-- TABS -->
      <section class="mt-4">
        <div class="container">
          <b-tabs
            content-class="mt-4 mt-lg-5"
            nav-class="default-tabs font-size-lg-medium"
          >
            <!-- PUBLICATIONS TAB -->
            <b-tab title="Publicações" active>
              <div v-if="posts.length > 0">
                <PostThumbList
                  class="mt-4"
                  :posts="posts"
                />
                <div class="mt-4 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="loaderPosts"
                    @click="loadMorePosts"
                    v-if="isLoadMorePostsVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else-if="loaderPosts"
              />
              <p class="text-center mt-4" v-else>Não foi encontrada nenhuma publicação para essa busca</p>
            </b-tab> <!-- END PUBLICATIONS TAB -->
            <!-- BOOKS TAB -->
            <b-tab title="Livros">
              <div v-if="books.length > 0">
                <BookThumbList
                  :books="books"
                  class="mt-4"
                />
                <div class="mt-4 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="loaderBooks"
                    @click="loadMoreBooks"
                    v-if="isLoadMoreBooksVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else-if="loaderBooks"
              />
              <p class="text-center mt-4" v-else>Não foi encontrado nenhum livro para essa busca</p>
            </b-tab> <!-- END BOOKS TAB -->

            <!-- GROUPS TAB -->
            <b-tab title="Comunidades">
              <div v-if="groups.length > 0">
                <div class="post-thumbs-listing listing-rowed items-2-per-row mt-4">
                  <ul class="list-wrap">
                    <li
                      class="list-item"
                      v-for="group in groups"
                      :key="group.id"
                    >
                      <GroupCard :group="group" />
                    </li>
                  </ul>
                </div>
                <div class="mt-4 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="loaderGroups"
                    @click="loadMoreGroups"
                    v-if="isLoadMoreGroupsVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else-if="loaderGroups"
              />
              <p class="text-center mt-4" v-else>Não foi encontrado nenhuma comunidade para essa busca</p>
            </b-tab> <!-- END GROUPS TAB -->

            <!-- USERS TAB -->
            <b-tab title="Usuários">
              <div v-if="users.length > 0">
                <div class="common-card-listing listing-rowed items-md-2-per-row items-lg-3-per-row mt-4 mt-lg-5">
                  <ul class="list-wrap">
                    <li
                      class="list-item"
                      v-for="user in users"
                      :key="user.id"
                    >
                      <UserProfileCard
                        :user="user"
                      />
                    </li>
                  </ul>
                </div>

                <div class="mt-4 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="loaderUsers"
                    @click="loadMoreUsers"
                    v-if="isLoadMoreUsersVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else-if="loaderPosts"
              />
              <p class="text-center mt-4" v-else>Não foi encontrado nenhum usuário para essa busca</p>
            </b-tab> <!-- END USERS TAB -->

            <!-- CATEGORIES TAB -->
            <b-tab title="Categorias">
              <div v-if="categories.length > 0">
                <div class="common-card-listing listing-rowed items-3-per-row mt-4 mt-lg-5">
                  <ul class="list-wrap">
                    <li
                      class="list-item"
                      v-for="category in categories"
                      :key="category.id"
                    >
                      <CategoryCard
                        :category="category"
                      />
                    </li>
                  </ul>
                </div>
                <div class="mt-4 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="loaderCategories"
                    @click="loadMoreCategories"
                    v-if="isLoadMoreCategoriesVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else-if="loaderCategories"
              />
              <p class="text-center mt-4" v-else>Não foi encontrada nenhuma categoria para essa busca</p>
            </b-tab> <!-- END CATEGORIES TAB -->

            <!-- TAGS TAB -->
            <b-tab title="Tags">
              <div v-if="tags.length > 0">
                <ul class="tag-list d-flex mb-3 flex-wrap">
                  <li class="tag-item mb-2 mr-4"
                    v-for="tag in tags"
                    :key="tag.id"
                  >
                    <router-link
                      :to="{ name: 'tags.show', params: { slug: tag.slug } }"
                    >
                      <span class="tag">{{ tag.name }}</span>
                    </router-link>
                  </li>
                </ul>
                <div class="mt-4 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="loaderTags"
                    @click="loadMoreTags"
                    v-if="isLoadMoreTagsVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else-if="loaderTags"
              />
              <p class="text-center mt-4" v-else>Não foi encontrada nenhuma tag para essa busca</p>
            </b-tab> <!-- END TAGS TAB -->

          </b-tabs>
        </div>
      </section> <!-- END TABS -->
  </div>
</template>

<script>

import BooksService from '@/modules/books/services/books-service'
import CategoriesService from '@/modules/categories/services/categories-service'
import GroupsService from '@/modules/groups/services/groups-service'
import PostsService from '@/modules/posts/services/posts-service'
import TagsService from '@/modules/tags/services/tags-service'
import UsersService from '@/modules/users/services/users-service'

import Button from '@/components/common/Button/Button.vue'
import BookThumbList from '@/components/books/BookThumbList.vue'
import CategoryCard from '@/components/categories/CategoryCard.vue'
import GroupCard from '@/components/groups/GroupCard'
import Loader from '@/components/common/Loader/Loader.vue'
import PostThumbList from '@/components/post/PostThumbList.vue'
import UserProfileCard from '@/components/user/UserProfileCard.vue'

export default {
  components: {
    Button,
    BookThumbList,
    CategoryCard,
    GroupCard,
    Loader,
    PostThumbList,
    UserProfileCard
  },
  data () {
    return {
      term: this.$route.query.term,
      posts: [],
      users: [],
      categories: [],
      tags: [],
      books: [],
      groups: [],
      pagePosts: 1,
      pageUsers: 1,
      pageCategories: 1,
      pageTags: 1,
      pageBooks: 1,
      pageGroups: 1,
      loaderPosts: false,
      loaderUsers: false,
      loaderCategories: false,
      loaderTags: false,
      loaderBooks: false,
      loaderGroups: false,
      isLoadMorePostsVisible: true,
      isLoadMoreUsersVisible: true,
      isLoadMoreCategoriesVisible: true,
      isLoadMoreTagsVisible: true,
      isLoadMoreBooksVisible: true,
      isLoadMoreGroupsVisible: true
    }
  },
  metaInfo () {
    return {
      title: `Busca por ${this.term}`
    }
  },
  created () {
    this.resetAndStart()
  },
  watch: {
    '$route' (to, from) {
      this.term = to.query.term
      this.resetAndStart()
    }
  },
  methods: {
    resetAndStart () {
      this.pagePosts = 1
      this.pageTags = 1
      this.pageUsers = 1
      this.pageCategories = 1
      this.pageBooks = 1
      this.pageGroups = 1
      this.posts = []
      this.tags = []
      this.users = []
      this.categories = []
      this.books = []
      this.groups = []
      this.getPosts()
      this.getUsers()
      this.getTags()
      this.getCategories()
      this.getBooks()
      this.getGroups()
    },
    async getPosts () {
      this.loaderPosts = true
      try {
        const posts = await PostsService.getPosts({ search: this.term, page: this.pagePosts })
        this.posts = [...this.posts, ...posts]
        this.isLoadMorePostsVisible = posts.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderPosts = false
    },
    async getUsers () {
      this.loaderUsers = true
      try {
        const users = await UsersService.getUsers({ search: this.term, page: this.pageUsers })
        this.users = [...this.users, ...users]
        this.isLoadMoreUsersVisible = users.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderUsers = false
    },
    async getCategories () {
      this.loaderCategories = true
      try {
        const categories = await CategoriesService.getCategories({ search: this.term, page: this.pageCategories })
        this.categories = [...this.categories, ...categories]
        this.isLoadMoreCategoriesVisible = categories.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderCategories = false
    },
    async getTags () {
      this.loaderTags = true
      try {
        const tags = await TagsService.getTags({ search: this.term, page: this.pageTags })
        this.tags = [...this.tags, ...tags]
        this.isLoadMoreTagsVisible = tags.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderTags = false
    },
    async getBooks () {
      this.loaderBooks = true
      try {
        const books = await BooksService.getBooks({ search: this.term, page: this.pageBooks })
        this.books = [...this.books, ...books]
        this.isLoadMoreBooksVisible = books.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderBooks = false
    },
    async getGroups () {
      this.loaderGroups = true
      try {
        const groups = await GroupsService.getGroups({ search: this.term, page: this.pageGroups })
        this.groups = [...this.groups, ...groups]
        this.isLoadMoreGroupsVisible = groups.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderGroups = false
    },
    loadMorePosts () {
      this.pagePosts++
      this.getPosts()
    },
    loadMoreUsers () {
      this.pageUsers++
      this.getUsers()
    },
    loadMoreCategories () {
      this.pageCategories++
      this.getCategories()
    },
    loadMoreTags () {
      this.pageTags++
      this.getTags()
    },
    loadMoreBooks () {
      this.pageBooks++
      this.getBooks()
    },
    loadMoreGroups () {
      this.pageGroups++
      this.getGroups()
    }
  }
}
</script>
